
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { Articulo } from '@/__env/lib/Articulos';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Publicacion() { return this.Controlador.Publicacion; }
        public get Articulo() { return this.Controlador.Articulo; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public Cargando: boolean = false;

        @Prop()
        public Codigo: Articulo;
        @Watch( 'Codigo' )
        onCodigo()
        {
            this.Descripcion = this.Publicacion.EditarDescripcion( this.Codigo );
        }

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Cargando = false;
            this.Abierto = true;
        }
        public Abierto: boolean = false;

        public Descripcion: string = '';

        async Guardar()
        {
            this.Cargando = true;
            let e = await this.Publicacion.ModificarDescripcion( this.Descripcion, this.Codigo.Id );
            if ( !e )
            {
                Utiles.Notificaciones.Error( 'Error al modificar la publicación' );
            }
            else
            {
                this.$emit( 'guardado', this.Codigo );
                this.Abierto = false;
            }
            this.Cargando = false;
        }

    }
